<script lang="ts">
    import { Evento, Videochiamata, StatoTempoEvento } from "./Evento";
    import PallinoStatoEvento from "./PallinoStatoEvento.svelte";
    import ModalWindow from "./ModalWindow.svelte";
    import Condividi from "./Condividi.svelte";
import { onMount } from "svelte";
    export let evento: Evento;

    function colora_scheda(e: Evento): string {
        //Ritorna la classe per colorare la scheda
        if (e.get_stato_tempo_evento() == StatoTempoEvento.PASSATO) {
            return "disattivato";
        } else if (e.get_stato_tempo_evento() == StatoTempoEvento.PRESENTE) {
            return "attuale";
        } else {
            return "futuro";
        }
    }

    function prima_maiusc(str: string): string
    {
        //Mette in maiuscolo la prima lettera
        return str.charAt(0).toUpperCase() + str.slice(1);
    }


    let html_evento;
    onMount(
        ()=>{
            if (location.hash == `#evento_${evento.pk}`)
            {
                html_evento.scrollIntoView();
            }
        }
    );

</script>

<style>
    .scheda {
        border-width: 0.1em;
        border-color: black;
    }
    .disattivato {
        opacity: 50%;
    }
    .attuale {
    }
    .futuro {
    }
</style>


<div bind:this="{html_evento}" id={"evento_"+String(evento.pk)} class="col-sm-12 col-md-4 col-lg-3">
    <div class="scheda card fluid {colora_scheda(evento)} ">
        <div class="section">
            <div class="row">
                <div class="col-sm-1">
                    <PallinoStatoEvento
                    stato={evento.get_stato_tempo_evento()} />
                </div>
                <div class="col-sm-8">
                    <h3>{evento.titolo}</h3>
                </div>
                <div class="col-sm-2">
                    {#if ! (evento.get_stato_tempo_evento()===StatoTempoEvento.PASSATO) }
                    <Condividi {evento}></Condividi>
                    {/if}
                    
                    
                </div>
            </div>
        </div>

        <small class="section">
        {prima_maiusc( evento.get_giorno_settimana() )}
        {evento.data_dd_mm_yyyy()},
        ore {evento.data_hh_mm()}</small>
        <div class="section">
            <p>{evento.descrizione}</p>
        </div>
        {#if evento.get_attivita_previste().length > 0}
        <div class="section">
            <details>
                <summary>Attività previste</summary>
                <ul>
                    {#each evento.get_attivita_previste() as attivita}
                    <li>{attivita}</li>
                    {/each}
                </ul>
            </details>
        </div>
        {/if}

        {#if evento.get_stato_tempo_evento() == StatoTempoEvento.PRESENTE}
            <a class="button" href={evento.get_link_videochat()}>Accedi
                alla videochiamata</a>
        {/if}
    </div>
</div>